
const KRajyotsavaData2025 = [
    {
        id: 1,
        imageSource: require("../../../Assets/Events/2025/Karnataka_Rajyotsava_2025/KR_2025_1.webp")
    },
    {
        id: 2,
        imageSource: require("../../../Assets/Events/2025/Karnataka_Rajyotsava_2025/KR_2025_2.webp")
    },
    {
        id: 3,
        imageSource: require("../../../Assets/Events/2025/Karnataka_Rajyotsava_2025/KR_2025_3.webp")
    },
    {
        id: 4,
        imageSource: require("../../../Assets/Events/2025/Karnataka_Rajyotsava_2025/KR_2025_4.webp")
    },
    {
        id: 5,
        imageSource: require("../../../Assets/Events/2025/Karnataka_Rajyotsava_2025/KR_2025_5.webp")
    },
    {
        id: 6,
        imageSource: require("../../../Assets/Events/2025/Karnataka_Rajyotsava_2025/KR_2025_6.webp")
    },
    {
        id: 7,
        imageSource: require("../../../Assets/Events/2025/Karnataka_Rajyotsava_2025/KR_2025_7.webp")
    },
    {
        id: 8,
        imageSource: require("../../../Assets/Events/2025/Karnataka_Rajyotsava_2025/KR_2025_8.webp")
    }
];

export default KRajyotsavaData2025;